function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const SOURCE_COLORS = {
    // new palettes, may have duplicates in legacy
    black900: '#000000',
    black800: 'rgb(0 0 0 / 90%)',
    emerald100: '#e3f2f6',
    emerald700: '#0a806b',
    green100: '#e7f3f0',
    green700: '#318643',
    red100: '#fff0f0',
    red400: 'f27373',
    red700: '#d24345',
    yellow100: '#faf1d7',
    yellow700: '#e8b738',
    white900: '#ffffff',
    grey100: '#f8f8f8',
    gray100: '#f8f8f8',
    grey200: '#efefef',
    gray200: '#efefef',
    grey300: '#dfdfdf',
    gray300: '#dfdfdf',
    grey400: '#c4c4c4',
    gray400: '#c4c4c4',
    grey500: '#9e9e9e',
    gray500: '#9e9e9e',
    grey600: '#707070',
    gray600: '#707070',
    grey700: '#5c5c5c',
    gray700: '#5c5c5c',
    grey800: '#313131',
    gray800: '#313131',
    grey900: '#151515',
    gray900: '#151515',
    // legacy palette
    white: '#ffffff',
    black: '#000000',
    charcoal: '#151515',
    graphite: '#313131',
    darkGrey: '#5c5c5c',
    mediumGrey: '#dfdfdf',
    platinum: '#efefef',
    lightGrey: '#f8f8f8',
    oceanBlue: '#44a2dd',
    skyBlue: '#73d2f2',
    lightBlue: '#e3f2f6',
    lightPink: '#fff0f0',
    red: '#d24345',
    mediumGreen: '#318643',
    lightGreen: '#e7f3f0',
    mediumYellow: '#e8b738',
    // rainbow
    scarlet: '#9a0202',
    mandarin: '#b3351a',
    rum: '#c94b2f',
    pumpkin: '#ba5d1a',
    caspian: '#204949',
    celtic: '#046240',
    emerald: '#0a806b',
    opal: '#c0e6df',
    talavera: '#2b3b55',
    atlantic: '#16618c',
    kingfisher: '#017eb4',
    rio: '#99d3f3',
    santorini: '#3b5ff3',
    ultramarine: '#3e3cbc',
    iris: '#6655d1',
    violet: '#844cbc',
    // deprecated
    brandBlue: '#0075c2',
    darkBlue: '#004471',
    accentGreen: '#0a806b',
    pink: '#e10096'
};
const GLOBAL_FONT = SOURCE_COLORS.black800;
const SEMANTIC_COLORS = {
    globalFont: GLOBAL_FONT,
    border: SOURCE_COLORS.grey300,
    discount: SOURCE_COLORS.emerald700,
    discountBackground: SOURCE_COLORS.green100,
    error: SOURCE_COLORS.red700,
    holiday: SOURCE_COLORS.scarlet,
    holidayBeige1: '#e8e1d6',
    holidayGreen1: '#576939',
    holidayGreen2: '#185d3f',
    holidayRed1: '#d9665b',
    holidayRed2: '#f7402f',
    icon: SOURCE_COLORS.grey900,
    link: GLOBAL_FONT,
    selected: SOURCE_COLORS.black900
};
const MARKETING_COLORS = {
    atlantic: SOURCE_COLORS.atlantic,
    caspian: SOURCE_COLORS.caspian,
    celtic: SOURCE_COLORS.celtic,
    darkGrey: SOURCE_COLORS.grey700,
    emerald: SOURCE_COLORS.emerald700,
    graphite: SOURCE_COLORS.grey800,
    holidayBeige1: SEMANTIC_COLORS.holidayBeige1,
    holidayGreen1: SEMANTIC_COLORS.holidayGreen1,
    holidayGreen2: SEMANTIC_COLORS.holidayGreen2,
    holidayRed1: SEMANTIC_COLORS.holidayRed1,
    holidayRed2: SEMANTIC_COLORS.holidayRed2,
    kingfisher: SOURCE_COLORS.kingfisher,
    mediumGreen: SOURCE_COLORS.green700,
    mediumGrey: SOURCE_COLORS.grey300,
    opal: SOURCE_COLORS.opal,
    platinum: SOURCE_COLORS.grey200,
    rio: SOURCE_COLORS.rio,
    talavera: SOURCE_COLORS.talavera
};
const MARKETING_BACKGROUNDS = {
    atlantic: 'atlantic',
    caspian: 'caspian',
    celtic: 'celtic',
    darkGrey: 'dark-grey',
    emerald: 'emerald',
    graphite: 'graphite',
    holidayBeige1: 'holiday-beige-1',
    holidayGreen1: 'holiday-green-1',
    holidayGreen2: 'holiday-green-2',
    holidayRed1: 'holiday-red-1',
    holidayRed2: 'holiday-red-2',
    kingfisher: 'kingfisher',
    mediumGreen: 'medium-green',
    mediumGrey: 'medium-grey',
    opal: 'opal',
    platinum: 'platinum',
    rio: 'rio',
    talavera: 'talavera'
};
const BACKGROUNDS = _object_spread_props(_object_spread({}, MARKETING_BACKGROUNDS), {
    black: 'black',
    black900: 'black-900',
    darkBlue: 'dark-blue',
    darkGray: 'dark-gray',
    discount: 'discount',
    emerald100: 'emerald-100',
    emerald700: 'emerald-700',
    green100: 'green-100',
    green700: 'green-700',
    gray100: 'gray-100',
    grey100: 'grey-100',
    grey200: 'grey-200',
    gray200: 'gray-200',
    grey300: 'grey-300',
    gray300: 'gray-300',
    grey400: 'grey-400',
    gray400: 'gray-400',
    grey500: 'grey-500',
    gray500: 'gray-500',
    grey600: 'grey-600',
    gray600: 'gray-600',
    grey700: 'grey-700',
    gray700: 'gray-700',
    grey800: 'grey-800',
    gray800: 'gray-800',
    grey900: 'grey-900',
    gray900: 'gray-900',
    holiday: 'holiday',
    iris: 'iris',
    lightBlue: 'light-blue',
    lightGray: 'light-gray',
    lightGrey: 'light-grey',
    loadingShimmer: 'loading-shimmer',
    mandarin: 'mandarin',
    mediumGray: 'medium-gray',
    mediumYellow: 'medium-yellow',
    pumpkin: 'pumpkin',
    rum: 'rum',
    santorini: 'santorini',
    scarlet: 'scarlet',
    ultramarine: 'ultramarine',
    violet: 'violet',
    white: 'white',
    white900: 'white-900',
    yellow700: 'yellow-700',
    transparent: 'transparent'
});
const TEXT_COLORS = {
    alert: 'alert',
    black: 'black',
    black800: 'black-800',
    error: 'error',
    darkGrey: 'dark-grey',
    darkGray: 'dark-gray',
    grey700: 'grey-700',
    gray700: 'gray-700',
    holiday: 'holiday',
    white: 'white'
};

export { BACKGROUNDS, GLOBAL_FONT, MARKETING_BACKGROUNDS, MARKETING_COLORS, SEMANTIC_COLORS, SOURCE_COLORS, TEXT_COLORS };
